import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const PURCHASES = [{
  name: 'María G.',
  country: 'México',
  time: 'hace 5 minutos'
}, {
  name: 'Carlos R.',
  country: 'Colombia',
  time: 'hace 12 minutos'
}, {
  name: 'Elena S.',
  country: 'España',
  time: 'hace 23 minutos'
}, {
  name: 'Roberto M.',
  country: 'Argentina',
  time: 'hace 34 minutos'
}, {
  name: 'Carmen L.',
  country: 'Chile',
  time: 'hace 41 minutos'
}];
export function SocialProofPopup() {
  const [currentPurchase, setCurrentPurchase] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    // Initial delay
    const initialTimer = setTimeout(() => {
      setIsVisible(true);
    }, 5000);
    // Cycle through purchases
    const interval = setInterval(() => {
      setIsVisible(false);
      setTimeout(() => {
        setCurrentPurchase(prev => (prev + 1) % PURCHASES.length);
        setIsVisible(true);
      }, 1000); // Wait 1s before showing next
    }, 15000); // Show a new one every 15s
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-6">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 25
    }} className="fixed bottom-4 left-4 z-50 bg-white rounded-lg shadow-2xl border border-gray-200 p-4 flex items-center gap-4 max-w-sm" data-id="element-7">
          <div className="bg-green-100 p-2 rounded-full" data-id="element-8">
            <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-9">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-10" />
            </svg>
          </div>
          <div data-id="element-11">
            <p className="text-sm text-gray-800 font-medium" data-id="element-12">
              <span className="font-bold" data-id="element-13">
                {PURCHASES[currentPurchase].name}
              </span>{' '}
              de {PURCHASES[currentPurchase].country}
            </p>
            <p className="text-xs text-gray-500" data-id="element-14">
              Compró Mente en Acción {PURCHASES[currentPurchase].time}
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}